import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import AddonsForm from "./AddonsForm";

const AddonsAdd = () => {
    return (
        <Fragment>
            <AddonsForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default AddonsAdd;